module.exports = __webpack_public_path__ + "img/top_mobile.3bae65cb.jpg";